export default "__VITE_ASSET__f573c301__"